import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { LoadingService } from '../../../../../app/shared/services/loading.service';
import { ComponentDetails, EquipmentDetails, SystemDetails } from '../../models/manage-equipment.model';
import { AppService } from '../../../../../app/app.service';
import moment from 'moment';
import { animate, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';
import { TranslateService } from '../../../../../app/translate';
import { CustomeEvaluationRangeVM } from '../../../../../app/modules/CustomEval/custom-eval.model';
import { CustomEvalService } from '../../../../../app/modules/CustomEval/custom-eval.service';
import { ScreenCode, toolType, toolTypePassFail, toolTypeYesNo } from '../../../../../app/shared/enums/allEnums';
import { PreferencesService } from '../../../../../app/modules/preferences/preferences.service';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../../../../app/modules/interpretation/interpretation.service';
import { MatDialog } from '@angular/material/dialog';
import { EditSystemSerialNumberComponent } from '../../../../../app/modules/interpretation/components/edit-system-serial-number/edit-system-serial-number.component';
import { TrackFrameConfigurationComponent } from '../track-frame-configuration/track-frame-configuration.component';
import { ChangeComponentComponent } from '../change-component/change-component.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-equipment-overview',
  templateUrl: './equipment-overview.component.html',
  styleUrls: ['./equipment-overview.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]
    )]

})
export class EquipmentOverviewComponent implements OnInit {
  loading: boolean = false;
  equipmentSystems: SystemDetails;
  equipmentSystemsCopy: SystemDetails;
  systemsLoaded = false;
  //  showFrameConfiguration: boolean = false;
  //showCannonType: boolean = false;
  hasCRoller: boolean = false;
  ShowCRoller: boolean = true;
  hasComponents: boolean = true;
  editableFrameCost: boolean;
  //equipmentDetails: EquipmentDetails;
  @Input() systemId: number = -1;
  @Input() equipmentID: number;
  @Input() isBasicUser: number;
  @Input() showCMU: boolean;
  @Input() showResLife100: boolean;
  showFrameConfiguration: boolean;
  @Input() showInstallDate: boolean;
  @Input() showResLife120: boolean;
  @Input() showDOC: boolean;
  @Input() showResDOC100: boolean;
  @Input() showResDOC120: boolean;
  @Input() isInspector: boolean;
  @Input() editComponent: boolean;
  @Input() showReading: boolean;
  @Input() showWorn0: boolean;
  @Input() showWorn100: boolean;
  @Input() showWorkOrder!: boolean;
  @Input() showBrand!: boolean;
  @Input() showBudgetLife!: boolean;
  @Input() showBushTurned!: boolean;
  @Input() showProjectedLife100!: boolean;
  @Input() showProjectedLife120!: boolean;
  @Input() showDifference!: boolean;
  @Input() showResidualDOC!: boolean;
  @Input() showPurchaseCost!: boolean;
  @Input() showRepairCost!: boolean;
  @Input() showActualWearRate!: boolean;
  @Input() showBudgetWearRate!: boolean;
  @Input() showHideCRoller!: boolean;
   @Input() showReplacementDate!: boolean;
  showCannonType: boolean;
  @Input() equipmentDetails: EquipmentDetails;
  @Output() hasComponentChange = new EventEmitter<boolean>();
  @Output() hasComponentCR = new EventEmitter<boolean>();
  @Input() EvalautionRange: CustomeEvaluationRangeVM;
    @Input() userUOM: string;
  public editableWO: boolean = true;
  public currentClickedId: string;
  public TogglePencil: boolean = false;
  enableBogieShim: boolean = false;
 
  toolType = toolType;
  toolTypeYesNo = toolTypeYesNo;
  toolTypePassFail = toolTypePassFail;
  hasAvailableMenuItems = false;
  eqName: string;
   ScreenCode = ScreenCode;
  //EvalautionRange: CustomeEvaluationRangeVM;
  constructor(private _dialog: MatDialog,
    private _interp: InterpretationService,
    private notification: NotificationsService,
    private readonly _pref: PreferencesService,
    private _evalService: CustomEvalService, private _translate: TranslateService, private _app: AppService, private _loading: LoadingService, private _equipmentService: ManageEquipmentService, private _sanitizer: DomSanitizer) { }

  ngOnInit(): void {
   
    console.log(this.isBasicUser, this.editComponent, this.equipmentDetails)
    //this.LoadEvalautionForEquipment();
    //  this.loadEquipmentDetails();
    this.loadEquipmentSystems();
  }

  // LoadEvalautionForEquipment() {
  //   this._evalService.GetSelectedLevelRangesForSelectedEquipment(this.equipmentID).subscribe(res => {
  //     this.EvalautionRange = res;
  //   })
  // }

  togglePencilClick() {
    this.TogglePencil = !this.TogglePencil;
  }

  getTitle(comp: ComponentDetails) {
    var OEM = comp.OEMPartNo;
    var MFR = comp.MFRPartNo;
    var value = "";
    if (OEM != null && MFR != null) {
      return value = "OEM Part# :" + OEM + '\n' + "Mfr.Part# :" + MFR;
    } else if (OEM != null) {
      return value = "OEM Part# :" + OEM;
    } else if (MFR != null) {
      return value = "Mfr.Part# :" + MFR;
    } else {
      return value;
    }
  }

  onSaveSystemFrameCost(Id: number, FrameCost: number) {
    this.editableFrameCost = true;
    this.UpdateFrame(Id, FrameCost);
  }

  updateSystemCondition(system: SystemDetails, newValue: string) {
    if (!this.isInspector)
      return;
    this._interp.updateSystemCondition(system.Id, newValue).subscribe(r => {
      if (r.m_Item1) {
        system.SystemCondition = newValue;
        system.SystemConditionColor = r.m_Item2;
        this.notification.success("Frame Condition updated successfully")
      } else {
        this.notification.error("Error while updating Frame Condition, Please contact Tracktreads Support")
      }
    })
  }

  UpdateFrame(Id: number, FCost: number) {
    this._interp.UpdateFrameCost(Id, FCost, ScreenCode.ME).subscribe(res => {
      if (res) {
        this.notification.success("Frame cost updated successfully")
      } else {
        this.notification.error("Error while updating Frame cost, Please contact Tracktreads Support")
      }
    })
  }

  UpdateBudgetDistance(Id: number, BudgetDistance: number) {
    this._interp.UpdateBudgetDistance(Id, BudgetDistance, ScreenCode.ME).subscribe(res => {
      if (res) {
        this.notification.success("Budget Distance updated successfully")
      } else {
        this.notification.error("Error while updating Budget Distance, Please contact Tracktreads Support")
      }
    })
  }

  onCancelSysBudgetLife() {
    this.editableSystemBudgetLife = true;
  }

  editSysBudgetDistance(type: number) {
    this.currentClickedId = type.toString();
    this.editableSysBudgetDistance = false;
  }

  onSaveSysBudgetDistance(Id: number, BudgetDistance: number) {
    this.editableSysBudgetDistance = true;
    this.UpdateBudgetDistance(Id, BudgetDistance);
  }

  onCancelSysBudgetDistance() {
    this.editableSysBudgetDistance = true;
  }

  editSysFrameCost(type: number) {
    this.currentClickedId = type.toString();
    this.editableFrameCost = false;
  }

  onCancelFrameCost() {
    this.editableFrameCost = true;
  }

  getAbs(absoluteToBe): number {
    return Math.abs(absoluteToBe);
  }

  getDifferenceClass(diffence: number) {
    if (diffence > 0) {
      return ' evalColorA';
    } else if (diffence < 0) {
      return ' evalColorX';
    } else { return 'DisplayNone'; }
  }

  getBushTurnbackgroudColour(comp: ComponentDetails) {
    if (comp.CompartTypeId == 231 && comp.IsBushTurned == false) {
      let bushbudgetless10percent = comp.BushTurnedPercent - 10;
      let bushbudgetless10percentLife = (comp.BushTurnedBudgetLife / comp.BushTurnedPercent) * bushbudgetless10percent;
      //check for red colour
      if ((comp.PercentWorn >= comp.BushTurnedPercent) || (comp.Cmu >= comp.BushTurnedBudgetLife)) {
        //console.log("if__XXX")
        return 'bushClass-X';
      }
      else if ((comp.PercentWorn >= bushbudgetless10percent && comp.PercentWorn < comp.BushTurnedPercent) || (comp.Cmu >= bushbudgetless10percentLife && comp.Cmu < comp.BushTurnedBudgetLife)) {
        //console.log("if__CCC")
        return 'bushClass-C';
      }
      else {
        // console.log("if__AAAA")
        return 'bushClass-A';
      }
    } else if (comp.CompartTypeId == 231 && comp.IsBushTurned == true) {
      return 'bushClass-U';
    }
  }
  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  userUOD: string = 'km';
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }

  showPosition(position: number, compartTypeId: number): string {

    if (this.equipmentSystems.Components.length > 4) {
      return this.getPositionStringDoubleComponents(position, compartTypeId);
    } else {
      return this._app.getPositionString(position, compartTypeId);
    }

  }
  getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
    if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
    if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 || Pos === undefined) {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';

    }
    if (CompartTypeId == 446)
      return 'Rear'
    return Pos.toString();
  }
  GetEvalColour(comp: ComponentDetails, worn: number) {
    if (this.EvalautionRange == null)
      return 'Eval-U';

    var compType = comp.CompartTypeId;
     if (comp.Reading === -1) {
       return 'Eval-U';
     }
 if(comp.ToolId === toolType.ConditionAssessment){
      if(comp.EvalCode === 'A') return 'Eval-A';
      else if(comp.EvalCode === 'B') return 'Eval-B';
      else if(comp.EvalCode === 'X') return 'Eval-X';
    }
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 231://Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.BushC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ShoeC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 233://Idler
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 234://carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CarrierRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 235://track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.TrackRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 236://Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.SprocketC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 240://Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ElongationC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 417://Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CrawlerGuideC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 446://RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.RSRearIdlerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 237://Idler

        if (worn <= 30)
          return 'Eval-A';
        else if (worn <= 50)
          return 'Eval-B';
        else if (worn <= 70)
          return 'Eval-C';
        else
          return 'Eval-X';


      default:
        break;
    }
  }

  loadEquipmentSystems() {
    this.loading = true;
    this._loading.startLoading();
    const today = new Date();
    this._equipmentService.getEquipmentBySystems(this.systemId, moment(today).format('MM/DD/YYYY').toString(), true).subscribe(systems => {
      this.equipmentSystems = systems;
      console.log("systems", systems);
      this.equipmentSystemsCopy = systems;
      this.getFamilyDetails(this.equipmentDetails.Family);
      this.systemsLoaded = true;
      this.showFrameConfiguration = this.equipmentSystems?.EnableFrameConfiguration;
      this.showCannonType = this.equipmentSystems?.EnableCannonType;
      this.enableBogieShim = this.equipmentDetails.EnableBogieShim;
      console.log(this.showFrameConfiguration, this.showCannonType);
      const hasComponentType234 = this.equipmentSystems.Components.some(component => component.CompartTypeId === 234);
      if (hasComponentType234) {
        this.hasCRoller = true;
        if (!this.showHideCRoller) {
          this.equipmentSystems.Components = this.equipmentSystems.Components.filter(x => x.CompartTypeId != 234)
        }
      } else {
        this.hasCRoller = false;
      }
      this.hasComponentCR.emit(this.hasCRoller);
      console.log(this.hasCRoller);
      if (this.equipmentSystems == null || this.equipmentSystems.Components.length == 0) {
        this.hasComponents = false;
      } else {
        this.hasComponents = true;
        this.hasComponentChange.emit(this.hasComponents);
      }
      this._loading.finishedLoading();
      this.checkAvailableMenuItems();
      this.loading = false;
    });
  }

  openTrackCofiguration(selectedType: number, selectedValue: number, systemId: number, Side: string) {
    const dialogRef = this._dialog.open(TrackFrameConfigurationComponent, {
      disableClose: true,
      width: '1032px',
      data: {
        selectedType: selectedType,
        selectedValue: selectedValue,
        systemId: systemId,
        equipmentId: this.equipmentID,
        screenId: ScreenCode.ME,
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (Side == "Left") {
        if (selectedType == 1) {
          this.equipmentSystems[1].ToeOutFrame = res;
          this.equipmentSystems[3].ToeOutFrame = res;
        }
        if (selectedType == 2)
          this.equipmentSystems[1].CastFrame = res;
      }
      else {
        if (selectedType == 1) {
          this.equipmentSystems[1].ToeOutFrame = res;
          this.equipmentSystems[3].ToeOutFrame = res;
        }
        if (selectedType == 2)
          this.equipmentSystems[3].CastFrame = res;
      }
      // this._equipmentService.getEquipmentSystems(this.equipmentId).subscribe(systems => {
      //     this.equipmentSystems = systems;
      // });
    });
  }

  checkAvailableMenuItems(): void {
    // Implement your logic to check if any of the buttons are available
    // For example, based on isInspector, isRopeShovel(), TempEnabled, ThermEnabled, etc.
    if (
      this.isInspector &&
      (!this.isRopeShovel() || this.hasComponents || !this.IsHtdrolicShovelWorksLikeRSH) ||
      this.isRopeShovel() ||
      (this.isInspector && this.IsHtdrolicShovelWorksLikeRSH) ||
      (this.isInspector && this.TempEnabled && this.hasComponents) ||
      (this.isInspector && this.ThermEnabled)
    ) {
      this.hasAvailableMenuItems = true;
    } else {
      this.hasAvailableMenuItems = false;
    }
  }
  ThermEnabled: boolean = false;
  TempEnabled: boolean = false;
  IsHtdrolicShovelWorksLikeRSH: boolean = false;
  CheckHydrolicIsInspectMeasurementPoint() {
    this._app.getApplicationConfigValue("HydrolicMeasurementPointEnabled").subscribe(result => {
      if (result == "1") {
        this.IsHtdrolicShovelWorksLikeRSH = true;
      } else {
        this.IsHtdrolicShovelWorksLikeRSH = false;

      }
    });

  }


  isRopeShovel(): boolean {
    if (this.equipmentDetails != null && this.equipmentDetails.Family === 'Rope Shovel') return true;
    //else if (this.equipmentDetails.Family === 'Hydraulic Shovel/Excavator'){
    // this._app.getApplicationConfigValue("HydrolicMeasurementPointEnabled").subscribe(result => {
    //     if(result=="1"){
    //         return true;
    //     }else{
    //         return false;
    //     }
    //  })
    else {
      return false;
    }


  }
  nextInspectionDate: string;
  IsAllowToggleCRoller: boolean = false;
  EnableDistTravelledTracking: boolean;
  ShowPropelHrsPerc: boolean;

  ThermographyEnabled: string;
  loadEquipmentDetails() {
    this._loading.startLoading();
    this._equipmentService.getEquipmentDetails(this.equipmentID).subscribe(equipment => {
      this.nextInspectionDate = equipment.NextInspectionDate;
      this.IsAllowToggleCRoller = equipment.AllowToggleCRoller;
      // console.log("IsAllowToggleCRoller", equipment.AllowToggleCRoller);
      // console.log("equipment", equipment);
      // let nextDate = new Date(this.nextInspectionDate);
      // let today = new Date();
      // if (today > nextDate) {
      //     console.log("overdue");
      // }
      this.equipmentDetails = equipment;
      this.EnableDistTravelledTracking = equipment.EnableDistTravelledTracking;
      this.ShowPropelHrsPerc = equipment.ShowPropelHrsPerc;
      this.eqName = this.equipmentDetails.SerialNumber;
      this.ShowCRoller = this.equipmentDetails.ShowHideCRoller;
      this.enableBogieShim = this.equipmentDetails.EnableBogieShim;
      console.log("enableBogieShim", this.enableBogieShim);
      this._app.setPageTitle('Manage Equipment | ' + equipment.SerialNumber + ' : ' + equipment.JobsiteName);
      this.getFamilyDetails(this.equipmentDetails.Family);
      this._loading.finishedLoading();
      this._app.getApplicationConfigValue("ThermographyEnabled").subscribe(result => {
        this.ThermographyEnabled = result
        if (this.ThermographyEnabled == "1") {
          if (this.equipmentDetails.IsThermographyEnable == true) {
            this.ThermEnabled = true;
            //this.loadEquipmentAllTypesInspections();
            //this.LoadTemperatureInspectionsForEquipment();
          } else
            this.ThermEnabled = false;
        } else {
          this.ThermEnabled = false;
        }

      });
      if (this.equipmentDetails.Family === 'Hydraulic Shovel/Excavator') {
        this.CheckHydrolicIsInspectMeasurementPoint();
      }


    });
  }
  FamilyImage_Chain: string;
  FamilyImage_Frame: string;
  isFamilyRS: boolean;
  getFamilyDetails(value: string) {
    console.log('value', value);
    this._equipmentService.getFamilyList().subscribe(result => {
      if (result != null) {
        const familydetails = result;
        familydetails.map(x => {
          //console.log("familydetails x:",x);
          if (x.typedesc === value) {
            this.FamilyImage_Chain = x.ChainImage;
            this.FamilyImage_Frame = x.FrameImage;
            if (x.typeid === 'RSH')
              this.isFamilyRS = true;
          }
        });
      }
    });
  }
  userLanguage = 'english';

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  EditSerial(sys: SystemDetails) {
    const editSeralNumber = this._dialog.open(EditSystemSerialNumberComponent, {
      data: {
        SerialNumber: sys.SerialNumber,
        systemId: sys.Id,
      }
    });
    editSeralNumber.afterClosed().subscribe(details => {
      if (details == true) {
        this._interp.GetSystemSerial(sys.Id).subscribe(res => {
          sys.SerialNumber = res;
        })
      }
    });
  }
  onSaveWO(ActionWOId: number, ActionWO: string) {
    this.editableWO = true;
    var model = { ActionWOId: ActionWOId, ActionWO: ActionWO };
    this._equipmentService.UpdateActionWO(model).subscribe(item => {
      if (item) {
        this.notification.success("Record saved succesfully.")
      }
    });
  }

  editWO(type: number) {
    this.currentClickedId = type.toString();
    this.editableWO = false;
  }
  onCancelWO() {
    this.editableWO = true;
  }
  public editableSystemBudgetLife: boolean = true;
  public editableSysBudgetDistance: boolean = true;
  public editableBudgetLife: boolean = true;
  editBudgetLife(type: number) {
    this.currentClickedId = type.toString();
    this.editableBudgetLife = false;
  }

  editSysBudgetLife(type: number) {
    this.currentClickedId = type.toString();
    this.editableSystemBudgetLife = false;
  }
  onSaveSysBudgetLife(Id: number, BudgetLife: number) {
    this.editableSystemBudgetLife = true;
    this.UpdateBudgetLife(Id, BudgetLife);
  }
  UpdateBudgetLife(Id: number, BudgetLife: number) {
    this._interp.UpdateBudgetLife(Id, BudgetLife, ScreenCode.ME).subscribe(res => {
      if (res) {
        this.notification.success("Budget Life updated successfully")
      } else {
        this.notification.error("Error while updating Budget Life, Please contact Tracktreads Support")
      }
    })
  }
 
  openEditComponentPopup(component: ComponentDetails) {
    //console.log("comparttype_auto: number, compartid_auto: number", CompartId, CompartTypeId);
    const viewModalRef = this._dialog.open(ChangeComponentComponent, {
      width: '500px',
      data: {
        eQunitId: component.Id,
        comparttype_auto: component.CompartTypeId,
        compartid_auto: component.CompartId,
        shoeSizeId: component.ShoeSize,
        shoeGrouserId: component.GrouserId,
        cleanerHolesId: component.CleanerHolesId,
        make: component.MakeId,
        budgetLife: component.BudgetLife,
        masterLink: component.MLink,
        jobNumber: component.JobNumber,
        bushTurnedBudgetPer: component.BushTurnedPercent,
        assetNumber: component.AssetNumber,
        bushTurnedHour: component.BushTurnedBudgetLife,
        wornPercentage: component.PercentWorn,
        cmu: component.Cmu,
        screenId: ScreenCode.ME
      }
    });
    viewModalRef.afterClosed().subscribe(result => {
      console.log("viewModalRef.afterClosed() result:", result);
      if (result) {
        this.loadEquipmentSystems();
      }
    });
  }



  getChildRowPosition(componentId: number): string {
    const component = this.getComponent(componentId);
    //const children = this.system.Components.filter(c => c.ComponentTypeId === component.ComponentTypeId && c.IsChild);
    const children = this.equipmentSystems.Components.filter(c => c.ParentComponentId === component.ParentComponentId);
    if (children.length > 0) {
      if (children[children.length - 1].Id === componentId) return '--half';
      else if (children[0].Id === componentId) return '--extended';
    }
    return '';
  }

  getComponent(componentId: number): any {
    return this.equipmentSystems.Components.find(c => c.Id === componentId);
  }
  isParent(componentId: number): boolean {
    const children = this.equipmentSystems.Components.filter(c => c.ParentComponentId === componentId && c.IsChild);
    if (children.length > 0) return true;
    return false;
  }
  sanitize(image: string) {

    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

}
